import React from 'react';

import Icon from './Icon';

export default function StrokeLinkIcon({
  className = '',
  text = 'Link',
}: { className?: string; text?: string }): JSX.Element {
  return (
    <Icon text={text}>
      <svg
        className={className}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M11.5305 4.41923C13.7771 2.22754 17.3528 2.23444 19.5531 4.43472C21.7534 6.635 21.7603 10.2107 19.5686 12.4573L19.562 12.464L17.7614 14.2646C17.4673 14.5587 16.9924 14.5608 16.7008 14.2692C16.4091 13.9775 16.4112 13.5027 16.7053 13.2085L18.5024 11.4113C20.1151 9.75487 20.109 7.12103 18.4879 5.49993C16.8668 3.87884 14.2329 3.8727 12.5765 5.48537L10.7794 7.28254C10.4852 7.57669 10.0103 7.57874 9.71871 7.28712C9.42708 6.99549 9.42911 6.52062 9.72326 6.22647L11.5305 4.41923Z" />
        <path d="M14.9814 9.00638C15.273 9.29802 15.2709 9.77288 14.9768 10.067L10.1526 14.8912C9.85844 15.1854 9.38357 15.1874 9.09194 14.8958C8.80031 14.6042 8.80235 14.1293 9.0965 13.8352L13.9207 9.01095C14.2149 8.7168 14.6897 8.71475 14.9814 9.00638Z" />
        <path d="M7.29455 10.7917C7.58871 10.4975 7.59076 10.0227 7.29913 9.73102C7.00751 9.43938 6.53264 9.44142 6.23848 9.73557L4.43781 11.5361L4.43125 11.5428C2.23955 13.7894 2.24646 17.3651 4.44674 19.5654C6.64702 21.7657 10.2228 21.7726 12.4693 19.5809L14.2766 17.7737C14.5708 17.4796 14.5728 17.0047 14.2812 16.7131C13.9896 16.4214 13.5147 16.4235 13.2205 16.7176L11.4233 18.5147C9.76689 20.1274 7.13305 20.1213 5.51195 18.5002C3.89085 16.8791 3.88472 14.2452 5.49738 12.5888L7.29455 10.7917Z" />
      </svg>
    </Icon>
  );
}
